import { AppError } from './app-error';
export class NotFoundError extends AppError{
    
}


// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/common/not-found-error.ts